var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.133,
    y: 0.5,
    width: 25.369,
    height: 17.613,
    rx: 3.5,
    fill: "#fff",
    stroke: "#E3EAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.956 13.052a5.275 5.275 0 01-3.412 1.242c-2.904 0-5.259-2.327-5.259-5.196 0-2.87 2.355-5.197 5.259-5.197 1.302 0 2.494.468 3.412 1.243A5.275 5.275 0 0117.368 3.9c2.904 0 5.259 2.327 5.259 5.197s-2.355 5.196-5.259 5.196a5.275 5.275 0 01-3.412-1.242z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.956 13.052a5.16 5.16 0 001.847-3.954c0-1.584-.717-3.001-1.847-3.954A5.275 5.275 0 0117.368 3.9c2.904 0 5.259 2.327 5.259 5.197s-2.355 5.196-5.259 5.196a5.275 5.275 0 01-3.412-1.242z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.956 13.052a5.16 5.16 0 001.847-3.954c0-1.584-.717-3.001-1.847-3.954a5.16 5.16 0 00-1.847 3.954c0 1.583.717 3 1.847 3.954z",
    fill: "#FD6020"
  })));
}
export default __webpack_public_path__ + "static/media/Mastercard.eb291d48.svg";
export { SvgMastercard as ReactComponent };